import React from "react";
import { TableCellLoaderProps } from "../../../../types";
import "./style.css";

const TableCellLoader: React.FC<TableCellLoaderProps> = ({
  width = "100%",
  height = "24px",
  animate = true,
}) => {
  return (
    <div className="loaderContainer">
      <div
        className={`loader ${animate ? "animate" : ""}`}
        style={{ width, height }}
      >
        <div className={`shimmer ${animate ? "shimmerAnimate" : ""}`} />
      </div>
    </div>
  );
};

export default TableCellLoader;
